export default "__VITE_ASSET__fa3fe07a__"